import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    position: relative;
    height: 100%;
    width: auto;
    aspect-ratio: 1;
    max-height: 100%;
    max-width: 100%;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    border-radius: ${theme.bo.medium};
    background-color: ${theme.co.neutral90};
    cursor: pointer;

    @media (max-width: ${theme.sz.md}) {
      height: auto;
      width: 100%;
    }
  `,
);

export const PlayButton = styled.button(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s12};
    height: ${theme.sz.s12};
    padding: 0;
    border: none;
    border-radius: ${theme.bo.round};
    background-color: rgba(0, 0, 0, 0.55);
    color: ${theme.co.neutral99};
    font-size: ${theme.sz.s5};
    cursor: pointer;
  `,
);

export const MediaIcon = styled.div(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.co.secondary20};
    font-size: ${theme.sz.s10};
    pointer-events: none;
  `,
);
